import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"
import React from 'react';
import { GallaryImage } from '../../assets/images/index';
import{motion} from 'framer-motion'
//Image40, Image37, Image38, Image39,Image21
import { Image1, Image4, Image5, Image6, Image7, Image8, Image9 , Image10, Image11, Image12, Image13, Image14, Image15, Image16, Image17, Image18, Image19, Image2, Image20, Image22, Image23, Image24, Image25, Image26, Image27, Image28, Image29, Image3, Image30, Image31, Image32, Image33, Image34, Image35, Image36, Image41
,Image42,
Image43,
Image44,
Image45,
Image46,
Image47,
Image48,
Image49,
Image50,
Image51,
Image52,
Image53,
Image54,
Image55,
Image56,
Image57,
Image59,
Image60,
Image61,
Image62,
Image63,
} from '../../assets/icons/gallery_icon/index'

const Gallary = () => {
    const images = [Image55,
Image56,
Image57,
        Image16,
Image48,
Image59,
Image63,

        Image22,
        Image25,
        Image33,
        Image34,
        Image1,
        Image2,
        Image3,
        Image4,
        Image5,
        Image6,
        Image7,
        Image9,
        Image10,
        Image11,
        Image12,
        Image13,
        Image14,
        Image15,
        Image17,
        Image18,
        Image19,
        Image20,
        // Image21,
        Image23,
        Image24,
        Image26,
        Image27,
        Image28,
        Image29,
        Image30,
        Image31,
        Image32,
        Image35,
        Image36,
        // Image37
        // Image38,
        // Image39,
        // Image40,
        Image8,
        Image41,
        Image42,
        
Image43,
Image44,
Image45,
Image46,
Image47,
Image49,
Image50,
Image51,
Image52,
Image53,
Image54,
Image60,
Image61,
Image62,

    ];
    console.log(images);
    
      const splitTextArray = (text) => {
        return text.split("").map((char, index) => (
          <motion.span
            key={index}
            initial={{ opacity: 0, y: -10 }} // Start slightly above
            animate={{ opacity: 1, y: 0 }}   // Animate to normal position
            transition={{
              delay: index * 0.05, // Faster staggered effect for characters
              duration: 0.3,
              ease: "easeOut",
            }}
            className="inline-block"
          >
            {char === " " ? "\u00A0" : char} {/* Preserve spaces */}
          </motion.span>
        ));
      };

    return (
        <div>
            <motion.div
        className="bg-cover bg-center bg-no-repeat w-full h-screen min-h-[300px] backdrop-blur-sm"
        style={{
          backgroundImage: `url(${GallaryImage})`,
          backgroundSize: 'cover', // Cover the entire container (ensure the image always covers the space)
          backgroundPosition: 'center', // Keep the image centered
        }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        whileInView={{ opacity: 1, y: 0 }} // Slide in from the top when in view
        viewport={{ once: true }} // Triggers animation when in view
            >
                <div className="flex justify-center items-center my-auto flex-col gap-[15px] fontText">
                    <div className="font-semibold text-[65px] text-[#ffffff] mt-[200px] max-md:text-[42px]">
                        {splitTextArray('Gallery')}
                    </div>
                </div>
            </motion.div>
            <div className="px-[50px] py-[100px] max-md:px-[30px]">
                <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}>
                    <Masonry>
                        {
                            images.map((image, i) => (
                                <img
                                    key={i}
                                    src={image}
                                    alt={image}
                                    style={{ width: '100%', display: "block" }}
                                />
                            ))
                        }
                    </Masonry>
                </ResponsiveMasonry>
            </div>
        </div>
    )
}

export default Gallary;